//@vendor
const Immutable = require('immutable');
const get = require('lodash/object/get');
//@action
const actionTypes = require('../../loansConstants/actionTypes');
const { EURO_SYMBOL } = require('constants/index');
//@helper
const { formatDate } = require('utilities/dateHelper');

const initialState = Immutable.fromJS({
    success: false,
    isFetching: true,
    error: false,
    owner: '',
    openingDate: '',
    initalExpirationDate: '',
    currentExpirationDate: '',
    initialCapital: {
        amount: 0,
        currency: EURO_SYMBOL
    },
    interestType: 0,
    interestMode: '',
    feeRegularity: '',
    feeRegularityDescription: ''
});

function prepareGeneralData(state, data) {

    let interestMode;
    // Logic provided by isban: https://jira.corp.globant.com/browse/OPB000-28544
    if (!data.modalidaTipoInteresDescuadre){
        interestMode = 'FIJO' + (data.modalidadTipoInteresActual ? (' ' + data.modalidadTipoInteresActual) : '');
    } else {
        interestMode = `${data.modalidaTipoInteresDescuadre} ${data.modalidadTipoInteresActual} ${data.modalidaTipoInteresDiferencial}`;
    }
    const generalData = {
        isFetching: false,
        success: true,
        error: false,
        interestMode,
        owner: get(data, 'titular'),
        openingDate: formatDate(get(data, 'fechaApertura')),
        initalExpirationDate: formatDate(get(data, 'fechaVencimientoInicial')),
        currentExpirationDate: formatDate(get(data, 'fechaVencimientoActual')),
        initialCapital: {
            amount: get(data, 'capitalInicial.importe'),
            currency: get(data, 'capitalInicial.divisa')
        },
        interestType: get(data, 'tipoInteres'),
        feeRegularity: get(data, 'periocidadCuotas'),
        feeRegularityDescription: get(data, 'descripcionPeriocidadCuotas')
    };

    return state.merge(generalData);
}

//This is a subreducer
function loanGeneralDataReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.FETCH_LOAN_GENERAL_DATA_FAILURE:
            return state.mergeDeep({
                error: action.payload.error,
                isFetching: false
            });
        case actionTypes.FETCH_LOAN_GENERAL_DATA_SUCCESS:
            return prepareGeneralData(state, action.payload.data);
        case actionTypes.FETCH_LOAN_GENERAL_DATA:
            return state.merge(initialState);
        default:
            return state;
    }
}

module.exports = loanGeneralDataReducer;
